import handleFetch from './handleFetch';

interface SearchParams {
  value: string;
  filters: string;
  limit?: number;
  lang?: 'en' | 'es';
  controller?: AbortController;
  type?: string;
}

interface SearchOptions {
  headers: {
    'x-algolia-application-id': string;
    'x-algolia-api-key': string;
    accept: string;
  };
  signal?: AbortSignal;
  errorKey: string;
}

const options: SearchOptions = {
  headers: {
    'x-algolia-application-id': process.env.SEARCH_APP_ID || '',
    'x-algolia-api-key': process.env.SEARCH_API_KEY || '',
    accept: 'application/json',
  },
  errorKey: 'Search failed.',
};

export const filteredSearch = ({
  value,
  filters,
  limit = 8,
  lang = 'en',
  controller,
}: SearchParams): Promise<Response | Error> => {
  const enUrl = process.env.PHARMACY_API_URL_EN;
  const esUrl = process.env.PHARMACY_API_URL_EN;

  const searchUrl = lang === 'es' ? esUrl : enUrl;

  if (controller) {
    options.signal = controller.signal;
  }

  return handleFetch(
    `${searchUrl}/?hitsPerPage=${limit}&query=${encodeURIComponent(value)}&filters=${filters}`,
    options
  );
};

const search = ({ value, limit = 8, lang = 'en', controller, type }: SearchParams): Promise<Response | Error> => {
  let enUrl = process.env.SEARCH_API_URL_EN;
  let esUrl = process.env.SEARCH_API_URL_ES;
  if (type === 'help') {
    enUrl = process.env.HELP_API_URL_EN;
    esUrl = process.env.HELP_API_URL_ES;
  }
  const searchUrl = lang === 'es' ? esUrl : enUrl;

  if (controller) {
    options.signal = controller.signal;
  }

  return handleFetch(`${searchUrl}/?hitsPerPage=${limit}&query=${encodeURIComponent(value)}`, options);
};

export default search;
